import { Store } from '@/store';

export * from './photos';

export enum Steps {
  Guidelines = 'guidelines',
  Take = 'take',
  Accept = 'accept',
  Accepted = 'accepted',
  AcceptDocument = 'acceptDocument'
}

export enum Errors {
  Unknown = 'unknown',
  PhotoLocked = 'photoLocked'
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $store: Store
  }
}